import type { AbgMarketingAssetPhase } from "./types";

export const APP_STORE_MARKETING_PHASE_KEYS = ["appStorePhone", "appStorePad"] as const;

export const APP_STORE_SCREENSHOT_PHASE_KEYS = ["appStore", ...APP_STORE_MARKETING_PHASE_KEYS] as const;

export const ABG_MARKETING_ASSET_PHASES = {
	abgPersona: "abgPersona",
	abgVideo: "abgVideo",
	ugcStartFrame: "ugcStartFrame",
	ugcVideo: "ugcVideo",
} as const;

export const ABG_MARKETING_ASSET_PHASE_KEYS = [
	ABG_MARKETING_ASSET_PHASES.abgPersona,
	ABG_MARKETING_ASSET_PHASES.abgVideo,
	ABG_MARKETING_ASSET_PHASES.ugcStartFrame,
	ABG_MARKETING_ASSET_PHASES.ugcVideo,
] as const satisfies readonly AbgMarketingAssetPhase[];

export function isAbgMarketingAssetPhase(phase: unknown): phase is AbgMarketingAssetPhase {
	return typeof phase === "string" && (ABG_MARKETING_ASSET_PHASE_KEYS as readonly string[]).includes(phase);
}
